export default __webpack_public_path__ + "static/media/gallery_04.d5a86911.jpg";